/**
 * vue-i18n setup. Locale order mirrors backend (en, uz, ru) so the
 * Accept-Language header we send always matches one of the backend
 * catalogs at app/i18n/locales/.
 */
import { createI18n } from "vue-i18n";
import en from "./en";
import uz from "./uz";
import ru from "./ru";

export const SUPPORTED_LOCALES = ["en", "uz", "ru"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const STORAGE_KEY = "admin.locale";

function detectLocale(): SupportedLocale {
  const saved = localStorage.getItem(STORAGE_KEY) as SupportedLocale | null;
  if (saved && SUPPORTED_LOCALES.includes(saved)) return saved;
  // Browser fallback — strip region, then check membership
  const browser = navigator.language?.split("-")[0] as SupportedLocale;
  return SUPPORTED_LOCALES.includes(browser) ? browser : "uz";
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: "en",
  messages: { en, uz, ru },
});

export function setLocale(locale: SupportedLocale): void {
  i18n.global.locale.value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}

export default i18n;
